import React from 'react';

import {
  Card,
  CardContent,
  Grid,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Step1Icon from 'src/components/GetStarted/Icons/HowItWorks/Step1Icon';
import Step2Icon from 'src/components/GetStarted/Icons/HowItWorks/Step2Icon';
import Step3Icon from 'src/components/GetStarted/Icons/HowItWorks/Step3Icon';

/**
 * Bottom banner to display How it works section
 */
const HowItWorks: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  const howItWorksSteps = [
    {
      icon: <Step1Icon />,
      description: `Select meals from our rotating menu of breakfast, lunch, dinner, snacks and family style options.`,
    },
    {
      icon: <Step2Icon />,
      description: `Submit your order and we do the rest! Your meals will be delivered directly to your doorstep.`,
    },
    {
      icon: <Step3Icon />,
      description: `Enjoy your healthy, delicious meals in minutes - no cooking or cleanup needed.`,
    },
  ];

  return (
    <div
      css={{
        width: '100%',
        overflowX: 'hidden',
        margin: '0 auto 0rem auto',
        paddingBottom: '2rem',
        backgroundColor: theme.palette.grey[50],
      }}
    >
      <Typography variant="h3" align="center">
        How it Works
      </Typography>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          maxWidth: theme.breakpoints.values.contentMaxWidth,
          margin: '0 auto',
        }}
      >
        {howItWorksSteps.map(({ icon, description }, idx) => (
          <Grid
            key={`alg-step${idx + 1} ${description}`}
            size={{
              xs: 12,
              md: 3,
            }}
          >
            <Card elevation={0} css={{ background: 'none' }}>
              <CardContent
                css={
                  isSmallScreen && idx !== 0 && { padding: '0 1rem', margin: 0 }
                }
              >
                <Stack css={{ textAlign: 'center' }}>
                  <div css={{ marginBottom: '1.5rem' }}>{icon}</div>
                  <Typography variant="body2">{description}</Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default HowItWorks;
